module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enrollment-switcher"
  }, [(_vm.otherEnrollments.length) ? _c('span', {
    staticClass: "toggle",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showMenu = !_vm.showMenu
      }
    }
  }, [_vm._v("…")]) : _vm._e(), _vm._v(" "), (_vm.currentEnrollment) ? _c('div', {
    staticClass: "selected-program"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Program")]), _vm._v(" "), (_vm.currentEnrollment.program) ? _c('div', {
    staticClass: "program-name"
  }, [_vm._v("\n            " + _vm._s(_vm.currentEnrollment.program.name) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("monthAndYear")(_vm.currentEnrollment.intake)) + " – " + _vm._s(_vm._f("monthAndYear")(_vm.currentEnrollment.endDate)))]), _vm._v(" "), _c('span', {
    staticClass: "pill"
  }, [_vm._v("\n            " + _vm._s(_vm.currentEnrollment.stage) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "unstyled"
  }, _vm._l((_vm.otherEnrollments), function(enrollment) {
    return _c('li', {
      key: enrollment.id,
      staticClass: "enrollment",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.switchEnrollments(enrollment.id)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("Program")]), _vm._v(" "), _c('div', {
      staticClass: "program-name"
    }, [_vm._v("\n                    " + _vm._s(enrollment.program.name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm._f("monthAndYear")(enrollment.intake)) + " – " + _vm._s(_vm._f("monthAndYear")(enrollment.endDate)))]), _vm._v(" "), _c('span', {
      staticClass: "pill"
    }, [_vm._v("\n                    " + _vm._s(enrollment.stage) + "\n                ")])])
  }))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2eab34e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/EnrollmentSelector.vue
// module id = 2007
// module chunks = 2